import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import './Welcome.css';
import './PageGracias.css';
import logo from '../assets/logo-publisearch.png';

function PageGracias() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="welcome">
        <div className="welcome-content">
          <div className="logo-container">
            <img src={logo} alt="Publisearch" className="logo" />
          </div>

          <div className="title-block">
            <h1 className="title">
              <span className="title-line1">Gracias</span>
              <span className="title-amp">por</span>
              <span className="title-line2">Acompa&ntilde;arnos</span>
            </h1>

            <div className="divider">
              <span className="divider-line"></span>
              <span className="divider-diamond"></span>
              <span className="divider-line"></span>
            </div>

            <p className="subtitle">
              <strong>Panorama 2025</strong> &amp; Tendencias 2026
            </p>
            <p className="role">
              Ricardo Martinez &middot; CEO Publisearch-AdvanceTMS
            </p>
          </div>

          <div className="country-badge">
            <span className="badge-flag">HN</span>
            <span className="badge-text">Honduras</span>
          </div>

          <div className="gracias-ai-notice">
            <p>Esta presentaci&oacute;n se construy&oacute; completamente utilizando <strong>PublisAI</strong>, Inteligencia Artificial con el <strong>MCP Server</strong> de Publisearch (Model Context Protocol).</p>
            <p className="gracias-ai-launch">Lanzamiento estimado para Q3 del 2026</p>
          </div>

          <button className="btn-start gracias-btn-back" onClick={() => navigate('/highlights')}>
            <span className="btn-arrow">&#8592;</span>
            Volver
          </button>
        </div>
      </div>
    </PageBackground>
  );
}

export default PageGracias;
